import React from 'react';
import {Link, useNavigate} from "react-router-dom";
import * as Yup from "yup";
import {AuthLayout} from "../../components/auth";
import {FullLogo} from "../../components/icons";
import {Button, Input} from "../../components/common";
import {ALERT_TYPES, BUTTON_TYPES, INPUT_TYPES, LS_KEYS, ROUTES} from "../../types";
import {useFormik} from "formik";
import {useMutation} from "react-query";
import {useAlert} from "../../components/common/Alert";
import {LS} from "../../utils";
import {log} from "util";

interface ISchema {
  [key: string]: string;
  username: string;
  password: string;
}

const {setToLS} = LS;

const SignIn = () => {
  const { setAlert } = useAlert();
  const navigate = useNavigate();

  const userSignIn = useMutation(["signIn"], {
    onMutate: (data: { username: string; password: string }) => {},
    onSuccess: (response) => {
      const { data: { access, refresh }}: any = response;
      setToLS(LS_KEYS.ACCESS_TOKEN, JSON.stringify(access));
      setToLS(LS_KEYS.REFRESH_TOKEN, JSON.stringify(refresh));
      navigate(ROUTES.APPLICATIONS);
    },
    onError: (e: any) => {
      const errorText: string = `${Object.values(e.response.data).flat(2)?.[0]}`;
      setAlert(errorText, ALERT_TYPES.ERROR);
    }
  })

  const validationSchema: Yup.Schema<ISchema> = Yup.object().shape({
    username: Yup.string().required('Поле не может быть пустым'),
    password: Yup.string().required('Пароль не может быть пустым'),
  });

  const submitForm = async (values: any) => {
    const { username, password } = values;
    await userSignIn.mutate({
      username,
      password
    })
  }

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    validationSchema: validationSchema,
    onSubmit: submitForm
  });

  const {
    errors, touched
  } = formik;

  const handleSubmit = () => formik.handleSubmit();

  return (
    <AuthLayout>
      <FullLogo className="mx-auto" />
      <div className="mt-6">
        <p className="text-[14px] leading-[24px] font-medium text-black mb-1">Логин</p>
        <Input
          id="username"
          name="username"
          className="w-full"
          placeholder="Введите логин"
          onChange={formik.handleChange}
          error={touched?.username ? errors?.username : false}
        />

        <p className="text-[14px] leading-[24px] font-medium text-black mt-4">Пароль</p>
        <Input
          id="password"
          name="password"
          className="w-full"
          type={INPUT_TYPES.PASSWORD}
          placeholder="Пароль"
          onChange={formik.handleChange}
          error={touched?.password ? errors?.password : false}
        />

        <Button
          title={'Войти'}
          onClick={handleSubmit}
          className="w-full mt-4"
        />

        {/*<Button*/}
        {/*  title={'Войти через Google'}*/}
        {/*  onClick={() => console.log('Войти')}*/}
        {/*  type={BUTTON_TYPES.GOOGLE}*/}
        {/*  className="w-full mt-1"*/}
        {/*/>*/}

        <div className="flex items-center justify-center mt-4">
          <p className="text-mainBlack/75 text-[12px] leading-[14px]">Еще не зарегистрировались?</p>
          <Link to={ROUTES.SIGN_UP} className="ml-1 text-primary text-[12px] leading-[14px] underline cursor:pointer">Зарегистрироваться</Link>
        </div>

        <div className="flex items-center justify-center mt-4">
          <Link to={ROUTES.RESET_PASSWORD} className="ml-1 text-primary text-[12px] leading-[14px] underline cursor:pointer">Забыли пароль?</Link>
        </div>
      </div>
    </AuthLayout>
  )
};

export default SignIn;
